import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { EditIcon } from "../../assets/Icons";
import Modal from "../Modal";
import Loader from "../Loader";
import { toast } from "react-toastify";

import {
  setGlobalData,
  setLocalData,
  deleteLocalData,
  setcsvReadedData,
} from "../../store/reducers/globalReducer";
import {
  useOpenAiCompletionRequestArrayMutation,
  useOpenAiCompletionRequestDescriptionArrayMutation,
} from "../../store/services/openAiService";
import UpdateDescriptionModel from "../UpdateDescriptionModel";

const GlobalDescription = ({ item }) => {
  const toastObject = {
    position: "top-center",
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    theme: "light",
  };
  const dispatch = useDispatch();
  const { globalData, localData, formInfo, lang } = useSelector(
    (state) => state.globalReducer
  );
  const { userId } = useSelector((state) => state.authReducer);

  const [selectedDescArray, setSelectedDescrray] = useState([]);
  const [openUpdateDescription, setOpenUpdateDescription] = useState(false);
  const [updatedDescriptionVal, setUpdatedDescriptionVal] = useState();
  const [updatedDescriptionIndex, setUpdatedDescriptionIndex] = useState();
  const [completionRequest, data] =
    useOpenAiCompletionRequestDescriptionArrayMutation();
  const [userInputProductName, setUserInputProductName] = useState(
    formInfo.name ? formInfo.name : ""
  );
  const [userInputProductDescription, setUserInputProductDescription] =
    useState(formInfo.pDesc ? formInfo.pDesc : "");
  const promptDescription = `Product Name: ${userInputProductName}\nProduct Description:${userInputProductDescription}\nAd Description:`;

  const submitCompletionRequestDescription = (e) => {
    if (userInputProductName === "") {
      toast.error("Enter Product Name!", toastObject);
    } else if (userInputProductDescription === "") {
      toast.error("Enter Product Description!", toastObject);
    } else {
      if (lang.value === "german") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Erstelle eine überzeugende Google Ads Beschreibung für das folgende Produkt. Stelle sicher, dass die Beschreibung maximal 90 Zeichen lang ist. Wie du weißt, können Personen auf deutsch formell und informell angesprochen werden. Wenn du den Nutzer im Text direkt ansprichst, verwende die informelle Ansprache “Du” in der zweiten Person Singular oder “Ihr” in der zweiten Person Plural. Zeichenbeschränkung: Description 1 - 90 Zeichen Description 2 - 90 Zeichen Beispiele: Description 1 - Ob zentrale Apartments, günstige Zimmer oder idyllische Ferienhäuser: Lass es Airbnb sein. Description 2 - Sichere Buchung & flexible Stornierungsmöglichkeiten. Jetzt Urlaub sorgenfrei planen! Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Description 1:`,
        });
      } else if (lang.value === "germanF") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Erstellen Sie eine überzeugende Google Ads Beschreibung für das folgende Produkt. Stellen Sie sicher, dass die Beschreibung maximal 90 Zeichen lang ist. Wie Sie wissen, können Personen auf deutsch formell und informell angesprochen werden. Wenn Sie den Nutzer im Text direkt ansprechen, verwenden Sie die höfliche Ansprache “Sie” in der dritten Person Plural. *Zeichenbeschränkung: Description 1 - 90 Zeichen Description 2 - 90 Zeichen Beispiele: Description 1 - Wir stehen Ihnen in allen Lebensbereichen mit hoher Kompetenz & Individualität zur Seite. Description 2 - Vertrauen Sie für Ihre Versicherungen auf mehr als 125 Jahre Qualität und Finanzstärke.* Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Description 1`,
        });
      } else if (lang.value === "germanInF") {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Erstelle eine überzeugende Google Ads Beschreibung für das folgende Produkt. Stelle sicher, dass die Beschreibung maximal 90 Zeichen lang ist. Wie du weißt, können Personen auf deutsch formell und informell angesprochen werden. Wenn du den Nutzer im Text direkt ansprichst, verwende die informelle Ansprache “Du” in der zweiten Person Singular oder “Ihr” in der zweiten Person Plural. *Zeichenbeschränkung: Description 1 - 90 Zeichen Description 2 - 90 Zeichen Beispiele: Description 1 - Ob zentrale Apartments, günstige Zimmer oder idyllische Ferienhäuser: Lass es Airbnb sein. Description 2 - Sichere Buchung & flexible Stornierungsmöglichkeiten. Jetzt Urlaub sorgenfrei planen!* Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Description 1`,
        });
      } else {
        completionRequest({
          userId: userId,
          model: "text-davinci-003",
          prompt: `Create a compelling Ad Description for the following Product to run on Google Search. Make sure to include up to 90 characters only. **Length limits: Description 1 - 90 characters Description 2 - 90 characters Examples: Description 1 - Get affordable & trustworthy insurance. 10% discount on all online quotes. Description 2 - Easily compare insurance plans side-by-side in just a few seconds.** Product Name: ${userInputProductName} Product Description:  ${userInputProductDescription} Description 1:`,
        });
      }
    }
  };

  useEffect(() => {
    if (data.isSuccess) {
      const updatedDescription = [
        ...globalData?.description,
        ...data.data.message,
      ];
      dispatch(
        setGlobalData({ ...globalData, description: updatedDescription })
      );
    }
  }, [data.isSuccess]);

  useEffect(() => {
    const oldDescription = [...globalData?.description];
    if (updatedDescriptionIndex !== -1) {
      oldDescription[updatedDescriptionIndex] = updatedDescriptionVal;
      dispatch(
        setGlobalData({
          ...globalData,
          description: oldDescription,
        })
      );
    }
  }, [updatedDescriptionVal]);

  useEffect(() => {
    setUserInputProductName(formInfo.pName ? formInfo.pName : "");
    setUserInputProductDescription(formInfo.pDesc ? formInfo.pDesc : "");
  }, [formInfo]);

  const handleDescArray = (e, item) => {
    // Destructuring
    const { value, checked } = e.target;

    // Case 1 : The user checks the box
    if (checked) {
      selectedDescArray.push(item.trim());
    }
    // Case 2  : The user unchecked the box
    else {
      let newSelectedDescArray = selectedDescArray.filter(function (
        filterItem
      ) {
        return filterItem.trim() !== item.trim();
      });
      setSelectedDescrray(newSelectedDescArray);
    }
  };
  const PostDesc = () => {
    if (selectedDescArray.length) {
      const updatedOldArray = localData.map((item, index) => {
        let newRow = { ...item };
        const keys = Object.keys(newRow);
        const count = keys.length;
        for (let i = 0; i < selectedDescArray.length; i++) {
          let headlineNum = count + i;
          newRow[`Description ${headlineNum}`] = selectedDescArray[i];
        }
        return newRow;
      });
      dispatch(setLocalData(updatedOldArray));
      toast.success("Description added successfully in all rows!", toastObject);
    }
  };

  return (
    <div className="global-row-expend-block flex flex-col">
      <div className="expend-row-headline flex flex-col items-center">
        <div className="expend-row-headline-top flex">
          <div className="input-field flex flex-col w-2/5">
            <div className="input-tag font-semibold text-base mb-2">
              Product/Service Name
            </div>
            <textarea
              id="pName"
              type="text"
              className="txt-seach-key w-full min-h-[100px] max-h-[100px] overflow-hidden"
              placeholder="Product/Service Name"
              value={userInputProductName}
              onChange={(e) => setUserInputProductName(e.target.value)}
            />
          </div>
          <div className="input-field flex flex-col w-full">
            <div className="input-tag font-semibold text-base mb-2">
              Product/Service Summary
            </div>
            <textarea
              type="text"
              className="txt-seach-key w-full min-h-[100px] max-h-[100px] overflow-hidden"
              placeholder="Product/Service Summary"
              value={userInputProductDescription}
              onChange={(e) => setUserInputProductDescription(e.target.value)}
            />
          </div>
          <input
            type="submit"
            value={data.isLoading ? "Processing..." : "Generate Ideas"}
            className="btn button h-12 mt-8"
            onClick={(e) => submitCompletionRequestDescription(e)}
          />
        </div>
        <div className="flex items-start my-3 w-full">
          <p className="text-lg text-red-700 font-semibold text-start w-full">
            Click Cloud Icon to generate a summary of your landing page
          </p>
        </div>
        <div className="flex items-center w-full">
          <div className="expend-tag flex flex-1 text-center items-center justify-center">
            Global Descriptions
          </div>
          <div className="btn button" onClick={(e) => PostDesc()}>
            Post to All Ads
          </div>
        </div>
      </div>
      <div className="expend-table-section flex flex-col">
        {data?.isLoading ? (
          <Loader />
        ) : (
          <>
            {globalData?.description?.length ? (
              <>
                {globalData?.description?.map((itm, idx) => (
                  <div key={idx} className="exp-row flex items-center">
                    <div className="exp-row-item flex items-center">
                      <div className="col-numb">{idx + 1}</div>
                      <div>
                        <input
                          onChange={(e) => {
                            handleDescArray(e, itm);
                          }}
                          type="checkbox"
                          className="check-box w-5 h-5"
                        />
                      </div>
                    </div>
                    <div className="exp-row-item flex items-center justify-center">
                      {itm === "---" ? null : (
                        <button className="btn button" disabled={true}>
                          {itm.length}
                        </button>
                      )}
                    </div>
                    <div className="exp-row-item flex items-center">
                      <div className="exp-row-tag">{itm ? itm : "--"}</div>
                    </div>
                    <div className="exp-row-item flex items-center justify-end">
                      <div
                        className="edit-icon flex items-center justify-center cursor-pointer"
                        onClick={(e) => {
                          setOpenUpdateDescription(true);
                          setUpdatedDescriptionVal(itm);
                          setUpdatedDescriptionIndex(idx);
                        }}
                      >
                        <EditIcon />
                      </div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <div className="expend-tag text-center font-semibold text-lg">
                Global Description Empty
              </div>
            )}
          </>
        )}
      </div>
      <Modal
        open={openUpdateDescription}
        onClose={() => setOpenUpdateDescription(false)}
      >
        <UpdateDescriptionModel
          setOpen={setOpenUpdateDescription}
          updatedDescriptionVal={updatedDescriptionVal}
          setUpdatedDescriptionVal={setUpdatedDescriptionVal}
        />
      </Modal>
    </div>
  );
};

export default GlobalDescription;
